"use client"

import { Settings2, HelpCircle } from "lucide-react"

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar"
import { ThemeToggle } from "@/components/ui/theme-toggle"
import { NavigationProps, AppPage } from "@/types/navigation"
import { ROUTES } from "@/routes/routes"

interface NavFooterProps extends NavigationProps {
  currentPage?: AppPage;
}

export function NavFooter({ onNavigate, currentPage }: NavFooterProps) {
  const footerItems = [
    {
      title: "Settings",
      icon: Settings2,
      url: ROUTES.SETTINGS,
      page: "settings" as const,
    },
    {
      title: "Get Help",
      icon: HelpCircle,
      url: ROUTES.HELP,
      page: "help" as const,
    },
  ]

  // Handle navigation for footer items
  const handleNavigation = (item: typeof footerItems[0], e: React.MouseEvent) => {
    // If we have a valid page to navigate to and the onNavigate function
    if (item.page) {
      e.preventDefault();
      onNavigate(item.page);
      return;
    }
  }

  return (
    <SidebarGroup>
      <SidebarMenu>
        {footerItems.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton 
              asChild 
              tooltip={item.title}
              isActive={currentPage === item.page}
            >
              <a 
                href={item.url}
                onClick={(e) => handleNavigation(item, e)}
              >
                {item.icon && <item.icon />}
                <span>{item.title}</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
        <SidebarMenuItem>
          <SidebarMenuButton tooltip="Toggle Theme">
            <ThemeToggle />
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
} 